import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { Typography } from '@mui/material';

interface NavigationLinkProps {
  href: string;
  label: string;
  icon?: ReactNode;
  isActive?: boolean;
  className?: string;
  onClick?: () => void;
  variant?: 'mobile' | 'desktop';
}

export const NavigationLink = ({
  href,
  icon,
  label,
  onClick,
  className,
  isActive = false,
  variant = 'desktop',
}: NavigationLinkProps) => {
  if (variant === 'desktop') {
    return (
      <Link
        to={href}
        className={twMerge(
          'text-black-primary hover:text-blue-primary active:text-blue-hover mt-0.75 flex h-16 items-center rounded-none border-b-4 border-solid border-transparent px-4 font-medium',
          isActive && 'border-blue-primary text-blue-primary'
        )}
      >
        {label}
      </Link>
    );
  }

  return (
    <Link
      to={href}
      onClick={onClick}
      className={twMerge(
        'flex items-center gap-2 p-6 transition-colors',
        className,
        isActive ? 'text-white-primary bg-blue-primary' : 'text-black-primary'
      )}
    >
      {icon && (
        <div
          className={twMerge(
            'text-lg',
            isActive ? 'text-blue-primary' : 'text-gray-400'
          )}
        >
          {icon}
        </div>
      )}
      <Typography variant="body1" className="font-medium">
        {label}
      </Typography>
    </Link>
  );
};
